module.exports = __webpack_public_path__ + "img/reviews-trust-logo_v1.c5c504a.png";